import { MatDialogConfig } from '@angular/material/dialog';
import { ICtaAnalyticsDialogData } from './cta-analytics-dialog.interface';

// Styled in src/styles/mat-dialog.scss: on phones this panel becomes a full-screen sheet.
export const CTA_ANALYTICS_DIALOG_BRIEFING_PANEL_CLASS = 'cta-analytics-dialog--briefing';

export function getCtaAnalyticsDialogConfig(data: ICtaAnalyticsDialogData): MatDialogConfig<ICtaAnalyticsDialogData> {
  return {
    data,
    maxWidth: '1800px',
    width: '90%',
    ...(data.creatorBriefingMode ? { panelClass: CTA_ANALYTICS_DIALOG_BRIEFING_PANEL_CLASS } : {}),
  };
}
